import { render, staticRenderFns } from "./salesStockOut-add-or-update.vue?vue&type=template&id=2a864297&scoped=true"
import script from "./salesStockOut-add-or-update.vue?vue&type=script&lang=js"
export * from "./salesStockOut-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./salesStockOut-add-or-update.vue?vue&type=style&index=0&id=2a864297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a864297",
  null
  
)

export default component.exports